var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhyRak1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.543,
    height: 54.623,
    viewBox: "0 0 48.543 54.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5700",
    "data-name": "Group 5700",
    transform: "translate(-7.803 -2.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14884",
    "data-name": "Path 14884",
    d: "M53.6,92.984a.885.885,0,0,0,.863.863h7.593a.885.885,0,0,0,.863-.863V88.9H53.6Z",
    transform: "translate(-19.455 -36.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14885",
    "data-name": "Path 14885",
    d: "M75.812,46.987h0a1.983,1.983,0,0,0-1.208-.805,1.788,1.788,0,0,0-1.726.69l-3.394,4.717c.058.115.173.173.23.288a3.543,3.543,0,0,1-.23,4.314l-.23.288a35.275,35.275,0,0,1-4.487,4.314l-1.323,1.093a1.024,1.024,0,1,1-1.265-1.611L63.5,59.181A35.527,35.527,0,0,0,67.76,55.1l.23-.288a1.473,1.473,0,0,0,.115-1.841,1.412,1.412,0,0,0-.978-.633,1.619,1.619,0,0,0-1.15.23l-7.305,5.119A4.447,4.447,0,0,0,57,59.986l-2.7,8.685h9.491l6.385-3.911a5.116,5.116,0,0,0,2.243-2.991l3.624-13.4A1.682,1.682,0,0,0,75.812,46.987Z",
    transform: "translate(-19.752 -18.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14886",
    "data-name": "Path 14886",
    d: "M26.956,60.144a4.23,4.23,0,0,0-1.668-2.3l-7.305-5.119a1.377,1.377,0,0,0-1.15-.23,1.412,1.412,0,0,0-.978.633,1.473,1.473,0,0,0,.115,1.841l.23.288a28.6,28.6,0,0,0,4.256,4.084l1.323,1.093a.82.82,0,0,1,.345.69,1.156,1.156,0,0,1-.23.748.82.82,0,0,1-.69.345,1.156,1.156,0,0,1-.748-.23l-1.323-1.093a39.755,39.755,0,0,1-4.487-4.314l-.23-.288a3.543,3.543,0,0,1-.23-4.314,1.01,1.01,0,0,1,.23-.288l-3.394-4.717a1.837,1.837,0,0,0-1.726-.69,1.6,1.6,0,0,0-1.208.805,1.777,1.777,0,0,0-.23,1.438l3.624,13.46a4.948,4.948,0,0,0,2.243,2.991l6.385,3.911H29.6Z",
    transform: "translate(0 -18.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14887",
    "data-name": "Path 14887",
    d: "M30.2,92.984a.885.885,0,0,0,.863.863h7.593a.885.885,0,0,0,.863-.863V88.9H30.2Z",
    transform: "translate(-9.514 -36.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14888",
    "data-name": "Path 14888",
    d: "M53.865,21.209a14.727,14.727,0,0,0-2.991-8.916,1.766,1.766,0,1,0-2.818,2.128,11.115,11.115,0,0,1,2.3,6.787,11.274,11.274,0,1,1-13.23-11.1v2.128a1.7,1.7,0,0,0,.863,1.438,1.771,1.771,0,0,0,.748.173,2.132,2.132,0,0,0,.863-.23l6.327-4.084a1.544,1.544,0,0,0,0-2.646L39.6,2.8a1.587,1.587,0,0,0-1.668-.058,1.625,1.625,0,0,0-.863,1.438V6.657A14.623,14.623,0,0,0,24.3,21.209a14.783,14.783,0,1,0,29.565,0Z",
    transform: "translate(-7.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14889",
    "data-name": "Path 14889",
    d: "M48.8,26.618l-5.464,5.464-2.243-2.243a1.749,1.749,0,0,0-2.473,2.473l3.509,3.509a1.805,1.805,0,0,0,2.531,0l6.73-6.73a1.736,1.736,0,0,0,0-2.473A1.876,1.876,0,0,0,48.8,26.618Z",
    transform: "translate(-12.87 -10.01)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhyRak1);
export default __webpack_public_path__ + "static/media/icon-why-rak-1.7108718585436da0f64ed6f8e38d7a19.svg";
export { ForwardRef as ReactComponent };